import { FC } from "react";
import { Button, Card } from "react-bootstrap";
import { CreateCuttlefishProjectResult, Product } from "../../models/types";

interface Props {
    product?: Product;
    result?: CreateCuttlefishProjectResult;
}

export const OpenInCuttlefishFooter: FC<Props> = ({ product, result }) => {
    console.log("[DEBUG] result ", result);
    console.log("[DEBUG] test json ", JSON.stringify(result));

    if (!product || !result || !result.project || !result.revision) {
        return null;
    }

    const project = result.project;
    const revision = result.revision;

    return (
        <Card.Footer className="d-flex justify-content-center align-items-center">
            <Button
                onClick={() => {
                    const openUrl = `cuttlefish://open?productId=${product?.id}&projectId=${project.id}&revisionId=${revision.id}&projectName=${encodeURIComponent(project.name)}&gitUrl=${encodeURIComponent("https://git.seepiagames.com/playableads/" + project.gitProjectName)}&gitSsh=${encodeURIComponent("ssh://git@git.seepiagames.com:2222/playableads/" + project.gitProjectName + ".git")}&branch=${encodeURIComponent(project.gitProjectBranch)}`;
                    console.log("[DEBUG] openUrl ", openUrl);
                    window.location.href = openUrl;
                }}
            >
                Open in Cuttlefish
            </Button>
        </Card.Footer>
    );
};
